import { render, staticRenderFns } from "./ApplyDonorListComp.vue?vue&type=template&id=6fd7cf80&scoped=true"
import script from "./ApplyDonorListComp.vue?vue&type=script&lang=js"
export * from "./ApplyDonorListComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd7cf80",
  null
  
)

export default component.exports